.pageType {
  text-transform: uppercase;
  font-weight: var(--font-weight-black);
}

.taxonomy {
  display: inline-block;
  border-radius: var(--border-radius-s);
  background: var(--color-svp-grey);
  padding: var(--space-xs) var(--space-s);
  margin-left: var(--space-s);
}

.defaultTemplate {
  font-weight: var(--font-weight-black);
  text-transform: uppercase;
}

.updated {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .initials {
    margin-left: var(--space-s);
  }
}

.row {
  cursor: pointer;
}
